/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:07/02/2021
 @Time:21:16
 **/
import VenteLigneBase from "./VenteLigneBase";
import ProduitPaquet from "../../produit/modele/ProduitPaquet";
import StockLigneProduitPaquet from "../../stock/model/StockLigneProduitPaquet";
import BonSortieLigneProduitPaquet from "../../bon_sortie/model/BonSortieLigneProduitPaquet";
import LangueService from "../../../i18n/service/LangueService";


export default class VenteLigneProduitPaquet extends VenteLigneBase{


    constructor() {
        super();
        this.discriminator="produitPaquet";
    }

    /**
     * @type{ProduitPaquet}
     */
    #_produitPaquet=null;

    /**
     * @type{number}
     */
    #_paquetage=0;

    /**
     * @type{StockLigneProduitPaquet} si la vente est effectué par un vendeur interne/gérant/gestionnaire
     */
    #_stockLigneProduitPaquet=null;


    /**
     *@type{BonSortieLigneProduitPaquet} si la vente est en cours de création par un vendeur externe (donc il est attaché a un bon de sortie)
     */
    #_bonSortieLigneProduitPaquet=null;


    get produitPaquet() {
        return this.#_produitPaquet;
    }

    set produitPaquet(value) {
        this.#_produitPaquet = value;
    }


    get stockLigneProduitPaquet() {
        return this.#_stockLigneProduitPaquet;
    }

    set stockLigneProduitPaquet(value) {
        this.#_stockLigneProduitPaquet = value;
    }

    get bonSortieLigneProduitPaquet() {
        return this.#_bonSortieLigneProduitPaquet;
    }

    set bonSortieLigneProduitPaquet(value) {
        this.#_bonSortieLigneProduitPaquet = value;
    }


    get paquetage() {
        return this.#_paquetage;
    }

    set paquetage(value) {
        this.#_paquetage = value;
    }

    getDesignation(locale=LangueService.getInstance().activeLangue.locale) {
        let designation=super.getDesignation(locale);
        if(designation===''&&this.produit!==null){
            designation=this.produitPaquet.getDesignation(locale);
            this.addDesignation(locale,designation);
        }
        return designation;
    }

    /**
     * retourne le prix totale d'une ligne TTC
     * @return {number}
     */
    getPrixTotaleTTC()
    {
        return super.getPrixTotaleTTC()*this.paquetage;
    }


    /**
     * retourne le totale Hors taxes
     * @return {number}
     */
    getPrixTotaleHTTC(){
        return super.getPrixTotaleHTTC()*this.paquetage;
    }


    static createObjetFromJson(venteLigneJson,venteLigne) {
        let venteLigneProduitPaquet=new VenteLigneProduitPaquet();
        super.createObjetFromJson(venteLigneJson,venteLigneProduitPaquet);
        if(venteLigneJson.produitPaquet!==null){
            venteLigneProduitPaquet.produitPaquet=ProduitPaquet.createProduitPaquetFromJson(venteLigneJson.produitPaquet);
            venteLigneProduitPaquet.paquetage=venteLigneProduitPaquet.produitPaquet.quantite;
        }
        return venteLigneProduitPaquet;
    }


    getQuantiteDisponiblePourVente() {
        if(this.#_bonSortieLigneProduitPaquet!==null)//vente en passant par bon sortie
        {
            return this.#_bonSortieLigneProduitPaquet.getQuantiteDisponibleVente();
        }else{//vente directe sans passer par bon sortie
            return this.#_stockLigneProduitPaquet.quantite;
        }
    }
}